import axios from 'axios'

const state = () => ({
  all: [],
})

const getters = {
  all (state) {
    return state.all
  },
}

const mutations = {
  SET_VEHICLE_TYPES (state, vehicleTypes) {
    state.all = vehicleTypes
  },
}

const actions = {
  async index ({ commit }, params) {
    const response = await axios.get('/vehicle-types', { params })
    commit('SET_VEHICLE_TYPES', response.data.data)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}